import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, createBlock as _createBlock, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-206046b6"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "tableHeader"
}
const _hoisted_2 = { key: 0 }
const _hoisted_3 = {
  key: 1,
  class: "searchBar"
}
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "horizontalLine" }, null, -1))
const _hoisted_5 = {
  key: 2,
  class: "scrollable"
}
const _hoisted_6 = {
  key: 0,
  style: {"margin-left":"45%"}
}
const _hoisted_7 = { key: 3 }
const _hoisted_8 = {
  key: 0,
  class: "links"
}
const _hoisted_9 = ["href"]
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_11 = ["href"]

import CollapsibleRow from "@/layout/collapsible/CollapsibleRow.vue";
import { CollapsableModel } from "@/../../EshJSLib/models/CollapsableModel";
import actionButton from "@/components/actionButton.vue";
import { patientStore } from "@/store/patient";
import { storeToRefs } from "pinia";
import SearchBar from "@/components/SearchBar.vue";
import { ref, onMounted } from "@vue/runtime-dom";
import { useRouter } from "vue-router";


export default /*#__PURE__*/_defineComponent({
  __name: 'CollapsibleContainer',
  props: {
  data: Object,
  textData: {
    type: Boolean,
    default: false,
  },
},
  emits: ["rowActions", "create-form", "search"],
  setup(__props, { emit }) {

const props = __props;

const router = useRouter();

const store = patientStore();
const { patient } = storeToRefs(store);



function createForm() {
   emit("create-form");
  
}

function rowAction(item: string, row: any, index: number) {
  emit("rowActions", item, row, index);
}

function doSearch(ev: string) {
  let searchword = ev.toLowerCase();
  let emptycheck = ev.replace(/\s/g, "");
  emit('search',searchword,emptycheck.length > 0);
}



return (_ctx: any,_cache: any) => {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!

  return (_openBlock(), _createElementBlock("div", null, [
    (
        (props.data?.layoutType === 'FormEdit' || props.data?.layoutType == null) &&
        props.data?.subtitle != null
      )
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          (props.data?.subtitle !== '')
            ? (_openBlock(), _createElementBlock("h1", _hoisted_2, _toDisplayString(props.data?.subtitle), 1))
            : _createCommentVNode("", true),
          (props.data?.headerIcon == 'plus' && _unref(patient)[props.data?.data] != null)
            ? (_openBlock(), _createBlock(actionButton, {
                key: 1,
                id: "Adder",
                iconname: props.data?.headerIcon,
                style: {"font-size":"35px","margin-right":"20px","cursor":"pointer"},
                colorbackground: "#11A696",
                onCallAction: _cache[0] || (_cache[0] = ($event: any) => (createForm()))
              }, null, 8, ["iconname"]))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true),
    (props.data?.headerIcon === 'search')
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _createVNode(SearchBar, {
            readonly: _unref(patient)[props.data?.data] == null,
            onCapture: _cache[1] || (_cache[1] = ($event: any) => (doSearch($event)))
          }, null, 8, ["readonly"])
        ]))
      : _createCommentVNode("", true),
    _hoisted_4,
    (props.data?.layoutType === 'FormEdit' || props.data?.layoutType == null)
      ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
          (_unref(patient)[props.data?.data]?.length == 0)
            ? (_openBlock(), _createElementBlock("p", _hoisted_6, _toDisplayString(_ctx.$t("noData")), 1))
            : _createCommentVNode("", true),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(store).patient![props.data?.data], (item, index) => {
            return (_openBlock(), _createBlock(CollapsibleRow, {
              key: index,
              row: item,
              data: __props.data,
              onRowActions: (n, r) => rowAction(n, r, index)
            }, null, 8, ["row", "data", "onRowActions"]))
          }), 128))
        ]))
      : _createCommentVNode("", true),
    (props.data?.textOrRow)
      ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
          (props.data?.title === 'Link utili')
            ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                _createElementVNode("a", {
                  href: props.data?.link1,
                  target: "_blank",
                  class: "link"
                }, [
                  _createVNode(_component_font_awesome_icon, { icon: ['fas', 'arrow-up-right-from-square'] }),
                  _createTextVNode(" " + _toDisplayString(_ctx.$t("Calendario Vaccinale")), 1)
                ], 8, _hoisted_9),
                _hoisted_10,
                _createElementVNode("a", {
                  href: props.data?.link2,
                  target: "_blank",
                  class: "link"
                }, [
                  _createVNode(_component_font_awesome_icon, { icon: ['fas', 'arrow-up-right-from-square'] }),
                  _createTextVNode(" " + _toDisplayString(_ctx.$t("Vaccinazioni per chi viaggia")), 1)
                ], 8, _hoisted_11)
              ]))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})